import React from 'react';
import { useResponsive } from 'ahooks';
import { Button, ConfigProvider } from '@fuxi/eevee-ui';

import cx from './index.module.css';

interface LoginButtonProps {
  loading?: boolean;
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

const LoginButton: React.FC<LoginButtonProps> = ({ loading, children, onClick, disabled }) => {
  const responsive = useResponsive();

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            controlHeight: 54,
            borderRadius: 54,
            contentFontSize: 20,
            paddingBlock: 13,

            controlHeightLG: 80,
            borderRadiusLG: 80,
            contentFontSizeLG: 30,
            paddingBlockLG: 22,
          },
        },
      }}>
      <div className={cx('login-button', disabled && 'login-button-disabled')} onClick={onClick}>
        <Button disabled={disabled} block size={responsive.xl ? 'large' : undefined} loading={loading}>
          {children}
        </Button>
      </div>
    </ConfigProvider>
  );
};
export default LoginButton;
